import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import { WorkflowModulePropagationStatus } from 'dashboard/models/workflow-module';
import Sticker from 'design-system/components/Sticker';
import { Variant } from 'design-system/theme';

const PROPAGATION_STATUS_TO_STICKER: Record<
  WorkflowModulePropagationStatus,
  [Exclude<Variant, 'inverse'>, string]
> = {
  [WorkflowModulePropagationStatus.Completed]: ['success', 'Updated'],
  [WorkflowModulePropagationStatus.Skipped]: ['danger', 'Failed'],
  [WorkflowModulePropagationStatus.Failed]: ['danger', 'Failed'],
  [WorkflowModulePropagationStatus.NotFound]: ['danger', 'Failed'],
};

const StickerContainer = styled('div')`
  display: grid;
  grid-auto-columns: min-content;
  grid-auto-flow: column;

  grid-column-gap: ${Spacing[2]};
  grid-row-gap: ${Spacing[2]};
  white-space: nowrap;
`;

interface PropagationStatusStickerProps {
  status: WorkflowModulePropagationStatus;
}

const PropagationStatusSticker = ({ status }: PropagationStatusStickerProps) => {
  const [variantType, statusMessage] = PROPAGATION_STATUS_TO_STICKER[status];

  return (
    <StickerContainer>
      <Sticker variant={variantType}>{statusMessage}</Sticker>
    </StickerContainer>
  );
};

export default PropagationStatusSticker;
